import { IPurchaseOrder } from "../../../models/PurchaseOrder";
import { useEffect, useState } from "react";
import { Fetch } from "../../../shared/Fetch";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { JVInput } from "../../../shared/JVInput";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { JVInputMask } from "../../../shared/JVInputMask";

export interface IConsultnat {
    consultant_ID?: number,
    consultant_Name?: string,
    consultant_Email_ID?: string,
    city_Name?: string,
    consultant_State?: string,
    consultant_Job_Title?: string,
    consultant_Home_No?: string,
    consultant_Cell_No?: string,
    visa_Name?: string,
    consultant_Status?: string,
    tax_Term?: string,
}

interface Iprops {
    po: IPurchaseOrder,
    toast: any,
    activeIndex: number,
    setActiveIndex: (index: number) => void,
    setNeedtoReload: (reload: boolean) => void
}
export interface IConsultantLegalDetails {
    id?: number
    consultant_ID?: number,
    consultant_Name: string,
    consultant_Email: string,
    consultant_Contact: string,
}
const schema = yup.object().shape({
    consultant_Name: yup.string().required("Consultant leagal name required"),
    consultant_Email: yup.string().required("Consultant  Email required"),
    consultant_Contact: yup.string().required("Consultant Number required"),

});
export const ConsultantInformation = (props: Iprops) => {
    const [consultantInfo, setConsultantInfo] = useState<IConsultnat>();
    const [usePoDetails, setUsePoDetails] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);

    const { control, handleSubmit, watch, formState: { errors }, reset } = useForm<IConsultantLegalDetails>({
        resolver: yupResolver(schema),
        defaultValues: {},
        shouldFocusError: false
    });

    useEffect(() => {
        reset({
            id: props.po?.consultant_Legal_Detail_Id,
            consultant_Name: props.po?.consultant_Legal_Name,
            consultant_Email: props.po?.consultant_Legal_Email,
            consultant_Contact: props.po?.consultant_Legal_Contact
        })
    }, [props.po])

    const onSubmit = async (data: IConsultantLegalDetails) => {
        setLoading(true);
        data.consultant_ID = props.po?.consultant_ID;

        if (data.id === undefined || data.id === null || data.id === 0) {
            delete data.id;
        }

        const method = props.po?.consultant_Legal_Detail_Id ? "PUT" : "POST";
        const message = props.po?.consultant_Legal_Detail_Id ? "Consultant Legal details Updated Successfully" : "Consultant Legal details Posted Successfully"
        const response = await Fetch("vwPODetails/ConsultantLegalDetails", method, data, null, props.toast);
        if (response) {
            const msg = await response.text();
            props.toast.current.show({ severity: 'success', content: msg });
            props.setActiveIndex(props.activeIndex + 1);
            props.setNeedtoReload(true);
        }
        setLoading(false);
    }

    const loadConsultantData = async () => {
        const response = await Fetch("Consultant_Mast/byId", "GET", null, `consultant_id=${props.po.consultant_ID}`, props.toast);
        if (response) {
            const data: IConsultnat = await response.json();
            setConsultantInfo(data);
        }
    }

    useEffect(() => {
        if (props.po.consultant_ID) { loadConsultantData(); }

    }, [props.po.consultant_ID]);

    const handleCheckboxChange = (e: any) => {
        const checked = e.checked;
        setUsePoDetails(checked);
        if (checked) {
            reset({
                consultant_Name: props.po.consultant_Name,
                consultant_Email: props.po.consultant_Email_id,
                consultant_Contact: props.po.consultant_Home_No || props.po.consultant_Cell_No
            });
        } else {
            reset({
                consultant_Name: "",
                consultant_Email: "",
                consultant_Contact: ""
            });
        }
    }

    return (
        <>
            <div className='w-11 m-auto mt-2'>
                <div className="grid formgrid">
                    <h5 className="field col-12 md:col-4 mt-4">Cons ID : <span className='text-600 font-light'>{consultantInfo?.consultant_ID}</span></h5>
                    <h5 className="field col-12 md:col-4">Name : <span className='text-600 font-light'></span>{consultantInfo?.consultant_Name}</h5>
                    <h5 className="field col-12 md:col-4">Email id : <span className='text-600 font-light'>{consultantInfo?.consultant_Email_ID}</span></h5>

                    <h5 className="field col-12 md:col-4">Job Title : <span className='text-600 font-light'>{consultantInfo?.consultant_Job_Title}</span></h5>
                    <h5 className="field col-12 md:col-4">Phone : <span className='text-600 font-light'>{consultantInfo?.consultant_Home_No}</span></h5>
                    <h5 className="field col-12 md:col-4">Cell No : <span className='text-600 font-light'>{consultantInfo?.consultant_Cell_No}</span></h5>

                    <h5 className="field col-12 md:col-4">Location : <span className='text-600 font-light'>{consultantInfo?.city_Name}, {consultantInfo?.consultant_State}</span></h5>
                    <h5 className="field col-12 md:col-4">Visa : <span className='text-600 font-light'>{consultantInfo?.visa_Name}</span></h5>
                    <h5 className="field col-12 md:col-4">Status : <span className='text-600 font-light'>{consultantInfo?.consultant_Status}</span></h5>
                </div>

                <div className="field-checkbox mt-3">
                    <Checkbox
                        inputId="usePo"
                        checked={usePoDetails}
                        onChange={handleCheckboxChange}
                    />
                    <label htmlFor="usePo" className="ml-2">Same as Consultant  Info</label>
                </div>
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid mt-5">

                    <JVInput required column={3} label="Consultant Legal Name" name="consultant_Name" control={control} error={errors.consultant_Name?.message} />
                    <JVInput required column={3} label="Consultant Legal Email " name="consultant_Email" control={control} error={errors.consultant_Email?.message} />
                    <JVInputMask column={3} mask="(999) 999-9999" required label="Consultant Legal Contact " name="consultant_Contact" control={control} error={errors.consultant_Contact?.message} />
                    <div className="field col-12 md:col-4">
                        <label htmlFor="">&nbsp;</label>
                        <Button loading={loading} type="submit" label='SAVE & NEXT'></Button>
                    </div>
                </form>
            </div>
        </>
    );
}